import React, { useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { TrendingUp, Check } from "lucide-react";
import { AuthContext } from "@/App";

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    // If user is already subscribed, this page was accessed directly
    // Redirect to dashboard after 3 seconds
    const timer = setTimeout(() => {
      navigate("/dashboard");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="bg-card border border-green-500/50 p-8 text-center">
          <div className="w-20 h-20 mx-auto bg-green-500/20 flex items-center justify-center mb-6">
            <Check className="w-10 h-10 text-green-500" />
          </div>
          <h1 className="text-2xl font-bold mb-2">Payment Successful!</h1>
          <p className="text-muted-foreground mb-6">
            Welcome to Aurex AI Pro. You now have unlimited access to all features.
          </p>
          <div className="space-y-3">
            <Link to="/dashboard">
              <Button className="w-full h-12 bg-white text-black hover:bg-gray-200 rounded-none uppercase tracking-wider font-bold">
                Go to Dashboard
              </Button>
            </Link>
          </div>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="flex items-center justify-center gap-2 text-muted-foreground hover:text-white transition-colors">
            <TrendingUp className="w-5 h-5" />
            <span className="font-bold">Aurex AI</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
